export default {
  UNSHIPPED: {
    value: 120,
    label: '未发货',
  },
  SHIPPED: {
    value: 121,
    label: '已发货',
  },
  RECEIVE: {
    value: 122,
    label: '已签收'
  }
}
